const config = {}

// Alterações pelo Sistema
let sistema = process.env.SISTEMA ? process.env.SISTEMA : 'dev'
let api = {}
let front = {}
let site = {}

site.urlLogin = 'http://localhost:8080/#/auth/login'

if (sistema === 'dev') {
  api.base = `//localhost:3000`
  api.consig = `//localhost:62604/api`
  front.url = `//localhost:8081`
  site.url = `//localhost:3001`
}
if (sistema === 'prod' || sistema === 'consig') {
  api.base = `//v1.api.app.consigvendas.com.br`
  api.consig = `//v2.api.app.consigvendas.com.br`
  front.url = `//app.consigvendas.com.br`
  site.url = `//consigvendas.com.br`
  site.urlLogin = 'http://promotora.consigvendas.com.br'
}
if (sistema === 'beta') {
  api.base = `//base.betaapi.salesoft.com.br`
}
if (sistema === 'homologation') {
  api.base = `//v1.api.hml.consigvendas.com.br`
  api.consig = `//v2.api.hml.consigvendas.com.br`
  front.url = `//hml.consigvendas.com.br`
  site.url = `http://site.hml.consigvendas.com.br`
  site.urlLogin = 'http://promotora.hml.consigvendas.com.br'
}
if (sistema === 'testing') {
  // api.base = `//api-hml-consigvendas.octoti.com.br:8088/v1`
  api.base = `//api.hml.consigvendas.com.br/v1`
  // api.consig = `//api-hml-consigvendas.octoti.com.br:8088/v2`
  api.consig = `//api.hml.consigvendas.com.br/v2`
  front.url = `//hml.cosigvendas.com.br`
  site.url = `//site.hml.consigvendas.com.br`
}

api.consig = process.env.API_CONSIG ? process.env.API_CONSIG : api.consig
api.base = process.env.API_BASE ? process.env.API_BASE : api.base
front.url = process.env.FRONT_URL ? process.env.FRONT_URL : front.url

// =============================== DEV ================================= //
config.development = {
  sistema,
  api,
  front,
  site,
  tempoSessao: 60 * 20, // em segundos (20 minutos)
  routerMode: false,
  app: '5b8ddb564455f5bab091ac6d2b0eba98',
  timeOut: 600,
  tempoVerificaCalculo: 15000,
  tempoVerificaCalculoInicial: 3000
}
// ========================== Production =============================== //
config.production = {
  sistema,
  api,
  front,
  site
}
// ============================= TEST ================================= //
config.test = {}

// Merge production e test no develop
config.production = Object.assign({}, config.development, config.production)
config.test = Object.assign({}, config.development, config.test)

// Env
const env = process.env.NODE_ENV ? process.env.NODE_ENV : 'development'
config[env].env = env

// Config
export default config[env]



// WEBPACK FOOTER //
// ./src/config.js